import Collection from "ampersand-collection";
import restMixin from "ampersand-collection-rest-mixin";
import lodashMixin from "ampersand-collection-lodash-mixin";
import ajaxMixin from "lib/ajax";
import url from "url";
import querystring from "querystring";

const MixedCollection = Collection.extend(lodashMixin, restMixin, ajaxMixin);

export default MixedCollection.extend({
    forceModuleName: false,
    idAttribute: "_id",
    mainIndex: "_id",
    templatize(templateFunction, options = {}) {
        if (options.sort && this.comparator !== options.sort) {
            this.comparator = options.sort;
            this.sort();
        }
        let results = this.models;
        if (options.filter) {
            if (Array.isArray(options.filter)) {
                for (const filter of options.filter) {
                    results = this.models.filter(filter.isMatch.bind(filter));
                    if (!this.models.length) {
                        break;
                    }
                }
            } else {
                results = this.models.filter(options.filter);
            }
        }
        return results.map(templateFunction);
    },
    reset: function (models, options) {
        this.nextData = null;
        return MixedCollection.prototype.reset.call(this, models, options);
    },

    cancelXHR: function () {
        if (this._xhr) {
            this._xhr.aborted = true;

            if (this._xhr.abort) {
                // legacy XmlHTTP
                this._xhr.abort();
            } else if (this._abortController.signal) {
                // fetch() API support
                this._abortController.abort();
            }

            this._xhr = null;
            this.trigger("abort");
        }
    },
    fetch: function (options = {}) {
        this.cancelXHR();

        if (options.reset) {
            this.nextData = null;
        }
        if (this.nextData) {
            options.data = this.nextData;
        }

        const fulfill = options.fulfill;

        // Monkey chain some pagination on
        const success = options.success;
        options.success = (model, data, optionsObj) => {
            this._xhr = null;
            if (optionsObj.xhr?.getResponseHeader?.("Next")) {
                model.nextData = querystring.parse(url.parse(optionsObj.xhr.getResponseHeader("Next")).query);
            } else {
                model.nextData = null;
            }
            if (success) {
                success(model, data, optionsObj);
            }
            if (fulfill) {
                fulfill();
            }
        };

        const error = options.error;
        options.error = (model, response, optionsObj) => {
            this._xhr = null;
            if (!optionsObj.xhr.aborted) {
                if (error) {
                    error(model, response, optionsObj);
                }
            }
            if (fulfill) {
                fulfill();
            }
        };

        this._abortController =
            typeof AbortController !== "undefined" ? new AbortController() : { abort: () => true, signal: null };
        options.signal = this._abortController.signal;

        this._xhr = MixedCollection.prototype.fetch.call(this, options);

        return this._xhr;
    },
    fetchByPromise: function (options = {}) {
        return new Promise((resolve, reject) => {
            const success = options.success;
            options.success = (model, data, optionsObj) => {
                if (success) {
                    success(model, data, optionsObj);
                }

                resolve(model, data, optionsObj.xhr);
            };

            const error = options.error;
            options.error = (model, response, optionsObj) => {
                if (!optionsObj.xhr.aborted) {
                    if (error) {
                        error(model, response, optionsObj);
                    }
                    const err = new Error((response.body && response.body.message) || "Unknown");
                    reject(err);
                }
            };

            this.fetch(options);
        });
    },
});
